<template>
  <div>
    <el-form label-position="left" label-width="144px">
      <el-form-item label="是否开启首页和搜索结果页弹窗">
        <el-switch v-model="form.popupwin_open" :active-value="1" :inactive-value="0" />
      </el-form-item>
      <el-form-item label="弹窗图片">
        <el-radio-group v-model="imgType" :disabled="isDisabled" @change="change">
          <el-radio label="0">使用通用弹窗</el-radio>
          <el-radio label="1">上传本地图片</el-radio>
        </el-radio-group>

        <div class="img-template" v-show="imgType == 0">
          <el-radio-group v-model="form.popupwin_bg_picture" :disabled="isDisabled">
            <el-radio-button label="1" ref="radio1">
              <svg-icon icon="correct" />
              <img :src="advert_template1" />
            </el-radio-button>
            <el-radio-button label="2">
              <svg-icon icon="correct" />
              <img :src="advert_template2" />
            </el-radio-button>
            <el-radio-button label="3">
              <svg-icon icon="correct" />
              <img :src="advert_template3" />
            </el-radio-button>
          </el-radio-group>
        </div>
        <div class="img-upload" v-show="imgType == 1">
          <custom-upload v-model="imgs" v-bind="uploadBind" :disabled="isDisabled"></custom-upload>
          <p class="help">请使用png格式，宽不小于640px</p>
        </div>
      </el-form-item>
      <el-form-item label="弹窗内文本" v-show="imgType != 1">
        <zt-input
          width="467px"
          placeholder="红包狂送！立减30元全场满减疯狂拿！"
          v-model="form.popupwin_ad_text"
          :disabled="isDisabled"
        />
      </el-form-item>
      <el-form-item label="按钮文本" v-show="imgType != 1">
        <zt-input
          width="106px"
          placeholder="立即领取"
          v-model="form.popupwin_button_text"
          :disabled="isDisabled"
        />
      </el-form-item>
      <el-form-item label="弹窗广告跳转方式">
        <zt-input width="273px" disabled :value="buttonUrl" />
        <span class="link" @click="settingVisible = true" :disabled="isDisabled">设置链接</span>
        <p class="help">请选择跳转方式</p>
      </el-form-item>
      <el-form-item label="弹窗生效时间">
        <el-date-picker
          v-model="datePickerModel"
          type="datetimerange"
          range-separator="至"
          start-placeholder="起始时间"
          end-placeholder="结束时间"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
          :clearable="false"
          :disabled="isDisabled"
        />
      </el-form-item>
      <el-form-item label="弹窗弹出频率">
        <el-radio-group v-model="form.popupwin_type" :disabled="isDisabled">
          <el-radio label="24h">24小时弹1次</el-radio>
          <el-radio label="0h">每次打开首页和搜索结果页都弹出</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <zt-button type="primary" width="140px" @click="onSave" :loading="loading">保存</zt-button>

    <!-- <setting-link-dialog
      v-model="settingVisible"
      :url="form.popupwin_button_url"
      @change="onChangeLink"
    /> -->
    <CmsEntrySelectPopup
      v-model="settingVisible"
      :value="form.popupwin_button_url"
      @confirm="onChangeLink"
    />
  </div>
</template>

<script>
import { taoke_cms_popupwin_set } from '@/api/cmsWebSite';
import advert_template1 from '@imgs/advert_template1.png';
import advert_template2 from '@imgs/advert_template2.png';
import advert_template3 from '@imgs/advert_template3.png';
// import SettingLinkDialog from "./components/SettingLinkDialog";
import { CmsEntrySelectPopup } from '@/components/CmsEntrySelect/index.js'
import CustomUpload from '@cps/CustomUpload';
import { mapGetters } from 'vuex';
export default {
  name: 'Advert',
  components: {
    // SettingLinkDialog,
    CustomUpload,
    CmsEntrySelectPopup,
  },
  data: () => ({
    loading: false,
    bufferUrl:'',
    form: {
      popupwin_open: 0,
      popupwin_bg_picture: '1',
      popupwin_ad_text: '',
      popupwin_button_text: '',
      popupwin_button_url: '',
      popupwin_time_begin: '',
      popupwin_time_end: '',
      popupwin_type: '24h',
    },

    imgType: '0', // 弹窗图片类型
    imgs: [],
    advert_template1,
    advert_template2,
    advert_template3,

    settingVisible: false,
  }),

  computed: {
    ...mapGetters(['popupwin']),

    isDisabled: (vm) => {
      return vm.form.popupwin_open != 1;
    },

    uploadBind: () => ({
      // childModal: false,
      emptyActions: ['upload', 'link'],
      sourceActions: ['delete'],
      multiple: false,
    }),

    datePickerModel: {
      get: (vm) =>
        [vm.form.popupwin_time_begin, vm.form.popupwin_time_end].filter((v) => v),
      set(val) {
        this.form.popupwin_time_begin = val[0];
        this.form.popupwin_time_end = val[1];
      },
    },

    buttonUrl: (vm) => {
      if (/^#/.test(vm.form.popupwin_button_url)) {
        return vm.$store.getters.cms_info.plugin_gfhb_share_url;
      }
      return vm.form.popupwin_button_url;
    },
  },
  watch: {
    popupwin: {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          for (const key in v) {
            this.form[key] = v[key];
          }
        }
      },
    },
    'form.popupwin_bg_picture': {
      deep: true,
      immediate: true,
      handler(v) {
        const isLink = isNaN(v - 0);
        this.imgType = isLink ? '1' : '0';

        if (!isLink) {
          this.imgs = [];
        } else if (!this.imgs.length || this.imgs[0].src != v) {
          this.imgs = [{ src: v }];
        }
      },
    },
    imgs: {
      deep: true,
      immediate: true,
      handler(v) {
        if (v.length) {
          this.form.popupwin_bg_picture = v[0].src;
        }
      },
    },
  },
  mounted() {},
  methods: {
    change(e) {
      if(e==1&&this.popupwin.popupwin_bg_picture.includes(['http'])) {
        this.form.popupwin_bg_picture = this.popupwin.popupwin_bg_picture
      }else if(this.popupwin.popupwin_bg_picture.includes(['http'])||this.form.popupwin_bg_picture.includes(['http'])) {
        this.$refs.radio1.$el.click()
      }
    },
    onChangeLink(event) {
      this.form.popupwin_button_url = event.url;
    },
    async onSave() {
      this.loading = true;
      const params = this.limitDiff(this.form, this.popupwin);
      params.popupwin_open = this.form.popupwin_open;

      const { data } = await taoke_cms_popupwin_set(params);
      if (data.error_code == 0) {
        this.$message.success('保存成功');
        this.$store.dispatch('GetCmsInfo');
      } else {
        this.$message.error(data.error_message);
      }
      this.loading = false;
    },

    limitDiff(obj1, obj2) {
      const copyObject = { ...obj1 };
      for (const k in obj1) {
        if (obj1[k] === obj2[k]) {
          delete copyObject[k];
        }
      }
      return copyObject;
    },
  },
};
</script>

<style lang="scss" scoped>
.img-template {
  .el-radio-button {
    margin-right: 20px;
    border-radius: 4px;
    overflow: hidden;
    border: none;
    background: #000;
    margin-top: 20px;
    border: 2px solid transparent;

    &.is-active {
      border-color: $theme;

      .svg-icon {
        display: block;
      }
    }
  }
  /deep/ {
    .el-radio-button__inner {
      padding: 0;
      border: none;
      background: none;
    }
    .el-radio-button__orig-radio {
      opacity: 0;
    }
  }
  img {
    display: block;
    width: 118px;
  }
  .svg-icon {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 24px;
    height: 24px;
    color: #fff;
    background: $theme;
    z-index: 1;
  }
}

.link {
  color: $theme;
  font-size: 14px;
  margin-left: 20px;
  cursor: pointer;

  &[disabled] {
    pointer-events: none;
  }
}
</style>

